import React from "react";
import GenericModal from "./GenericModal";

type DeleteConfirmModalProps = {
    itemName: string;
    onConfirm: () => void;
    onClose: () => void;
};

export default function DeleteConfirmModal({
    itemName,
    onConfirm,
    onClose,
}: DeleteConfirmModalProps) {
    return (
        <GenericModal title="Megerősítés">
            <p className="mb-4">
                Biztosan törölni szeretnéd ezt az elemet: <strong>{itemName}</strong>?
            </p>

            <div className="flex justify-end space-x-3">
                <button
                    onClick={onConfirm}
                    className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                >
                    Törlés
                </button>
                <button
                    onClick={onClose}
                    className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                >
                    Mégse
                </button>
            </div>
        </GenericModal>
    );
}
